import Colors from '@studykik/ui-library/dist/Model/colors';
import styled from 'styled-components';

export const BalanceLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${Colors.TextSecondary};
`;

export const Available = styled.div`
  font-weight: 600;
  font-size: 21px;
  white-space: nowrap;
`;

export const BalanceContainer = styled.div`
  display: flex;
  color: ${Colors.TextMain};
  line-height: 1;
  gap: 4px;
  align-items: end;
  flex-wrap: wrap;
`;

export const Pending = styled.div`
  line-height: 1;
  color: ${Colors.TextSecondary};
  font-size: 13px;
  transform: translateY(-2px);
  white-space: nowrap;
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ClaimSummaryWrapper = styled.div`
  width: 100%;
  padding: 16px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${Colors.White};
  margin-top: 16px;

  @media (min-width: 1000px) {
    width: 1000px;
    margin: 16px auto 0;
  }

  .MuiCircularProgress-svg {
    color: ${Colors.Primary};
  }
`;
